import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

export default function ListingPage() {
  // SEO Configuration
  useSEO({
    title: 'Browse Professional Painters in Cape Town | PAINTERRR Directory',
    description: 'Find and compare professional house painters across Cape Town. Browse our directory of trusted, experienced painting contractors serving all areas of Cape Town and surrounds.',
    keywords: 'painters Cape Town, house painters, painting contractors, professional painters, residential painters, commercial painters',
  });

  const [isScrolled, setIsScrolled] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // All painters data
  const painters = [
    {
      name: "Pro Painters Table View",
      location: "Table View, Cape Town",
      areas: ["Table View", "Blouberg", "Milnerton"],
      rating: 5,
      reviews: 47,
      image: "https://public.readdy.ai/ai/img_res/83a22edc61df7f70df6b7f1871fb926c.jpg",
      link: "/listing-painters-table-view",
      specialty: "Residential & Commercial"
    },
    {
      name: "Pro Painters Milnerton",
      location: "Milnerton, Cape Town",
      areas: ["Milnerton", "Table View", "Century City"],
      rating: 5,
      reviews: 38,
      image: "https://readdy.ai/api/search-image?query=skilled%20painters%20applying%20paint%20to%20residential%20building%20exterior%20professional%20work%20scene%20with%20ladders%20and%20equipment%20simple%20background&width=600&height=400&seq=painter2&orientation=landscape",
      link: "/listing-painters-pro-painters-milnerton",
      specialty: "Interior & Exterior"
    },
    {
      name: "Painters Bantry Bay",
      location: "Bantry Bay, Cape Town",
      areas: ["Bantry Bay", "Sea Point", "Clifton"],
      rating: 5,
      reviews: 42,
      image: "https://readdy.ai/api/search-image?query=professional%20painters%20working%20on%20luxury%20home%20exterior%20painting%20project%20with%20modern%20equipment%20coastal%20area%20simple%20background&width=600&height=400&seq=painter3&orientation=landscape",
      link: "/listing-painters-bantry-bay",
      specialty: "Luxury Homes"
    },
    {
      name: "Bellville Painters",
      location: "Bellville, Cape Town",
      areas: ["Bellville", "Parow", "Goodwood"],
      rating: 5,
      reviews: 35,
      image: "https://readdy.ai/api/search-image?query=painting%20contractors%20working%20on%20commercial%20building%20exterior%20with%20scaffolding%20professional%20setup%20simple%20background&width=600&height=400&seq=painter4&orientation=landscape",
      link: "/listing-painters-bellville-painters",
      specialty: "Commercial Projects"
    },
    {
      name: "Big Bay Painters",
      location: "Big Bay, Cape Town",
      areas: ["Big Bay", "Bloubergstrand", "West Beach"],
      rating: 5,
      reviews: 29,
      image: "https://readdy.ai/api/search-image?query=house%20painters%20applying%20fresh%20paint%20to%20residential%20property%20exterior%20with%20professional%20tools%20coastal%20setting%20simple%20background&width=600&height=400&seq=painter5&orientation=landscape",
      link: "/listing-painters-big-bay",
      specialty: "Residential Painting"
    },
    {
      name: "Bishopscourt Painters",
      location: "Bishopscourt, Cape Town",
      areas: ["Bishopscourt", "Constantia", "Wynberg"],
      rating: 5,
      reviews: 31,
      image: "https://readdy.ai/api/search-image?query=professional%20painters%20working%20on%20upscale%20residential%20property%20exterior%20painting%20with%20quality%20equipment%20simple%20background&width=600&height=400&seq=painter6&orientation=landscape",
      link: "/listing-painters-bishopscourt",
      specialty: "Premium Properties"
    },
    {
      name: "Bloubergstrand Painters",
      location: "Bloubergstrand, Cape Town",
      areas: ["Bloubergstrand", "Table View", "Melkbosstrand"],
      rating: 5,
      reviews: 44,
      image: "https://readdy.ai/api/search-image?query=painting%20team%20working%20on%20beachside%20home%20exterior%20with%20professional%20equipment%20coastal%20area%20simple%20background&width=600&height=400&seq=painter7&orientation=landscape",
      link: "/listing-painters-bloubergstrand",
      specialty: "Coastal Properties"
    },
    {
      name: "Camps Bay Painters",
      location: "Camps Bay, Cape Town",
      areas: ["Camps Bay", "Clifton", "Bantry Bay"],
      rating: 5,
      reviews: 39,
      image: "https://readdy.ai/api/search-image?query=professional%20painters%20working%20on%20luxury%20coastal%20home%20exterior%20painting%20project%20with%20modern%20tools%20simple%20background&width=600&height=400&seq=painter8&orientation=landscape",
      link: "/listing-painters-camps-bay",
      specialty: "Luxury Coastal Homes"
    },
    {
      name: "Cape Town Central Painters",
      location: "Cape Town CBD",
      areas: ["Cape Town CBD", "Woodstock", "Green Point"],
      rating: 5,
      reviews: 52,
      image: "https://readdy.ai/api/search-image?query=painting%20contractors%20working%20on%20urban%20building%20exterior%20with%20professional%20equipment%20city%20setting%20simple%20background&width=600&height=400&seq=painter9&orientation=landscape",
      link: "/listing-painters-cape-town",
      specialty: "Urban Properties"
    },
    {
      name: "Claremont Painters",
      location: "Claremont, Cape Town",
      areas: ["Claremont", "Newlands", "Rondebosch"],
      rating: 5,
      reviews: 36,
      image: "https://readdy.ai/api/search-image?query=house%20painters%20applying%20paint%20to%20suburban%20residential%20property%20with%20professional%20tools%20simple%20background&width=600&height=400&seq=painter10&orientation=landscape",
      link: "/listing-painters-claremont",
      specialty: "Suburban Homes"
    },
    {
      name: "Durbanville Painters",
      location: "Durbanville, Cape Town",
      areas: ["Durbanville", "Brackenfell", "Bellville"],
      rating: 5,
      reviews: 41,
      image: "https://readdy.ai/api/search-image?query=professional%20painting%20team%20working%20on%20residential%20home%20exterior%20with%20equipment%20northern%20suburbs%20simple%20background&width=600&height=400&seq=painter11&orientation=landscape",
      link: "/listing-painters-durbanville",
      specialty: "Northern Suburbs"
    },
    {
      name: "Somerset West Painters",
      location: "Somerset West, Cape Town",
      areas: ["Somerset West", "Strand", "Gordon's Bay"],
      rating: 5,
      reviews: 33,
      image: "https://readdy.ai/api/search-image?query=painters%20working%20on%20residential%20property%20exterior%20painting%20with%20professional%20tools%20helderberg%20area%20simple%20background&width=600&height=400&seq=painter12&orientation=landscape",
      link: "/listing-painters-somerset-west",
      specialty: "Helderberg Area"
    }
  ];

  const filteredPainters = painters.filter(painter =>
    painter.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    painter.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
    painter.areas.some(area => area.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`sticky top-0 z-50 border-b border-gray-800 transition-all duration-300 ${isScrolled ? 'bg-black text-white' : 'bg-black text-white'}`}>
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-3xl font-bold whitespace-nowrap">
              <span className="text-white">PAINTE</span>
              <span className="text-[#e9f638]">RRR</span>
            </Link>
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="hover:text-[#e9f638] transition whitespace-nowrap">Home</Link>
              <Link to="/listing" className="hover:text-[#e9f638] transition whitespace-nowrap">Browse Painters</Link>
              <Link to="/about" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">
                About
              </Link>
              <Link to="/contact" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">
                Contact
              </Link>
              <Link to="/get-a-quote" className="bg-[#e9f638] text-black px-6 py-2 rounded-lg font-semibold hover:bg-white transition whitespace-nowrap cursor-pointer">Get a Quote</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Browse Professional Painters</h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Find trusted, experienced painting contractors across Cape Town and surrounding areas
          </p>
          
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <input
                type="text"
                placeholder="Search by area or painter name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-6 py-4 pr-12 rounded-lg text-black text-lg focus:outline-none focus:ring-4 focus:ring-[#e9f638]"
              />
              <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-2xl text-gray-400"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Painters Grid */}
      <div className="container mx-auto px-4 py-16">
        <div className="mb-8">
          <p className="text-lg text-gray-600">
            Showing <strong>{filteredPainters.length}</strong> professional painters
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPainters.map((painter, index) => (
            <Link
              key={index}
              to={painter.link}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="h-64 w-full overflow-hidden">
                <img
                  src={painter.image}
                  alt={painter.name}
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold mb-2">{painter.name}</h3>
                <div className="flex items-center text-gray-600 mb-3">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span>{painter.location}</span>
                </div>
                <div className="flex items-center mb-3">
                  <div className="flex mr-2">
                    {[...Array(painter.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#e9f638]"></i>
                    ))}
                  </div>
                  <span className="text-gray-600">({painter.reviews} reviews)</span>
                </div>
                <div className="mb-4">
                  <span className="inline-block bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm font-semibold">
                    {painter.specialty}
                  </span>
                </div>
                <div className="mb-4">
                  <p className="text-sm text-gray-600">
                    <strong>Service Areas:</strong> {painter.areas.join(', ')}
                  </p>
                </div>
                <div className="flex items-center text-[#e9f638] font-semibold">
                  View Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredPainters.length === 0 && (
          <div className="text-center py-16">
            <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
            <h3 className="text-2xl font-bold text-gray-700 mb-2">No painters found</h3>
            <p className="text-gray-600">Try adjusting your search terms</p>
          </div>
        )}
      </div>

      {/* CTA Section */}
      <div className="bg-[#e9f638] py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Transform Your Space?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Get free quotes from multiple professional painters in your area
          </p>
          <Link
            to="/get-a-quote"
            className="inline-block bg-black text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-800 transition whitespace-nowrap cursor-pointer"
          >
            Get Free Quotes
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black text-white border-t border-gray-800">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold mb-4">
                <span className="text-white">PAINTE</span>
                <span className="text-[#e9f638]">RRR</span>
              </h3>
              <p className="text-gray-400">South Africa's premier directory for professional house painters.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4 text-[#e9f638]">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-[#e9f638] cursor-pointer">Home</Link></li>
                <li><Link to="/listing" className="text-gray-400 hover:text-[#e9f638] cursor-pointer">Browse Painters</Link></li>
                <li><Link to="/get-a-quote" className="text-gray-400 hover:text-[#e9f638] cursor-pointer">Get a Quote</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4 text-[#e9f638]">Popular Areas</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Table View</li>
                <li>Cape Town CBD</li>
                <li>Durbanville</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4 text-[#e9f638]">Connect</h4>
              <p className="text-gray-400">Find the perfect painter for your project today.</p>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>© 2025 PAINTERRR. All rights reserved.</p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a href="https://leaderr.co/" target="_blank" rel="noopener noreferrer" className="hover:text-[#e9f638] cursor-pointer">
                Powered by leaderr
              </a>
              <span>|</span>
              <a href="https://seostudio.co.za/" target="_blank" rel="noopener noreferrer" className="hover:text-[#e9f638] cursor-pointer">
                SEO by SEO Studio
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
